<template>
    <div>
        <template v-if="log_shipping == true">
            <div class="page-top mb-1 mb-3">
                <h1> Add Log Shipping </h1>
            </div>
            <div class="global-main">
                <form id="onboardingDocumentForm" @submit.prevent="addLogShippingDocument" novalidate>
                    <div class="tab-content-inner">
                        <div class="form-group">
                            <label> Table Name <em class="required">*</em> </label>
                            <select v-model="form.table_name" data-live-search="true" name="table_name" class="selectpicker custom-select2 form-control" :class="{ 'is-invalid': form.errors.has('table_name') }" v-if="tableNameslist != null" >
                                <option value="" selected>Select Table Name</option>
                                <option v-for="table in tableNameslist" v-bind:value="table.table_name" >{{ table.table_name }}  ({{table.rows_count}})</option>
                            </select>
                            <has-error :form="form" field="table_name"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Day of month <em class="required">*</em></label>
                            <select id="daysDropdown" multiple v-model="form.day_of_month" class=" selectpicker form-control custom-select2" :class="{ 'is-invalid': form.errors.has('day_of_month') }">
                                <option v-for="day in totalMonthDays" :key="day" :value="day">{{ day }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label> Retention Days <em class="required">*</em></label>
                            <input
                                    type="number"
                                    v-model="form.retention_days"
                                    min="0"
                                    :max="999999"
                                    pattern="[0-9]{1,6}"
                                    class="form-control"
                                    :class="{ 'is-invalid': form.errors.has('retention_days') }"
                                    required
                            >
                            <has-error :form="form" field="retention_days"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Status <em class="required">*</em></label>
                            <select v-model="form.status" name="status_select" class=" selectpicker form-control custom-select2" :class="{ 'is-invalid': form.errors.has('status') }">
                                <option value="ON">ON</option>
                                <option value="OFF">OFF</option>
                            </select>
                            <has-error :form="form" field="status"></has-error>
                        </div>
                    </div>
                    <div class="form-group">
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/logshippingComponent" class="btn btn-primary float-right mr-2">Cancel</router-link>
                    </div>

                </form>
            </div>
        </template>
        <template v-else-if="log_shipping === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="log_shipping === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                form: new Form({
                    table_name: "",
                    day_of_month:"",
                    retention_days:'',
                    status:""
                }),
                log_shipping: null,
                tableNameslist:{},
                totalMonthDays: [],

            };
        },
        methods: {
            addLogShippingDocument() {
                let newForm= new FormData()
                $.each(this.form, (key, value) => {
                    if (key !== 'busy' && key !== 'successful' && key !== 'errors' && key !== 'originalData') {
                        newForm.append(key, value);
                    }
                });
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                axios.post('/api/logShipping',newForm, config)
                    .then(res => {
                        if(res.data.code == 200){
                            if(res.data.code == '200'){
                                this.showToastBox("success", "Log Shipping added successfully");
                                this.$router.push("/logshippingComponent");
                            }else{
                                var error_msg = '';
                                error_msg = 'Please provide following details:'+'\n';
                                $.each(res.data.data, (key, value) => {
                                    error_msg += value +'\n';
                                });
                                this.showAlertBox('error',error_msg);
                            }
                        }else{
                            this.showAlertBox('error','Some problem in your form data');
                        }
                    }).then(res=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                    .catch(errors => {
                        this.promptValidationErrors(errors);
                    });
            },
            generateTotalDays() {
                for (let i = 1; i <= 28; i++) {
                    this.totalMonthDays.push(i);
                }
            },
            getTableNameList() {
                axios
                    .get("/api/logShipping/tableNames")
                    .then((res) => {
                        this.tableNameslist = res.data.data;
                    })
                    .then(res => {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                    })
                    .catch(err => {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        console.log(err);
                    });
            },
        },
        mounted() {
            this.can("log_shipping")
                .then((result) => {
                    this.log_shipping = result.log_shipping;
                })
                .then((result) => {
                    if (this.log_shipping == true) {
                        this.generateTotalDays();
                        this.getTableNameList()
                        $('#sample_file_div').hide();
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        this.$Progress.finish();
                    } else {
                        this.$Progress.finish();
                    }
                });
        },
    }
</script>